import Vue from 'vue';
import VueMatchHeights from 'vue-match-heights';
import constants from '../constants';
import Partner from './partner';
import FeatureSwitch from './feature-switch';
import Whitelabel from './whitelabel';
import Bus from './bus';
import ViewData from './view-data';
import LodashGet from './lodash-get';
import VueLazyLoad from 'vue-lazyload';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import VueApollo from 'vue-apollo';
import VueLaroute from './laroute';
import VueNoty from 'vuejs-noty';

/**
 * Create a simple data provider plugin
 *
 * @param {String} key
 * @param {Object} object
 * @returns {{install(*): void}}
 */
export function provideVariables(key, object) {
    return {
        install(Vue) {
            Vue.prototype[key] = object;
        },
    };
}

const defaultPlugins = {
    VueMatchHeights,
    Partner,
    Whitelabel,
    FeatureSwitch,
    Bus,
    Vuex,
    VueResource,
    VueApollo,
    ViewData,
    LodashGet,
    VueLazyLoad: [VueLazyLoad, {
        lazyComponent: true,
        lazyImage: true,
    }],
    VueNoty: [VueNoty, {
        timeout: 4000,
        progressBar: true,
        layout: 'topRight',
        theme: 'yps',
    }],
    $const: provideVariables('$const', constants),
    $laroute: VueLaroute,
};

/**
 * Load global Vue Plugins
 *
 * @param {Object} plugins
 */
export const loader = (plugins = defaultPlugins) => {
    Object.keys(plugins).forEach((plugin) => {
        let options;
        let instance = plugins[plugin];
        if (instance instanceof Array) {
            [instance, options] = instance;
        }
        Vue.use(instance, options);
    });
};
